import React, { useEffect, useState } from 'react'
import styles from './GoalsChart.module.scss'
import { ReactComponent as Flag } from 'components/CRM/UI/icons/flag.svg'
import Location from '../Location/Location'
import ManagerRow from '../ManagerRow/ManagerRow'
import st from '../ManagerRow/ManagerRow.module.scss'

const GoalsChart = ({ goals, translate, dates }) => {
  const [sortBy, setSortBy] = useState('budget')

  const dateFrom = new Date(dates?.[0]?.date_from)
  const dateUntil = new Date(dates?.[0]?.date_until)

  const todayDate = new Date()
  const currentDay = todayDate.getDate()
  const millisecondsPerDay = 1000 * 60 * 60 * 24
  const daysInPeriod =
    Math.round((dateUntil - dateFrom) / millisecondsPerDay) + 1

  const totalBudgetTarget = goals.reduce(
    (sum, school) =>
      sum +
      school.managers.reduce(
        (managerSum, manager) => managerSum + Number(manager.budget),
        0,
      ),
    0,
  )

  const currentDayTotal =
    todayDate >= dateFrom && todayDate <= dateUntil
      ? Math.ceil((todayDate - dateFrom) / (1000 * 60 * 60 * 24))
      : 0

  useEffect(() => {
    // Получаем положение первого progress-bar и выставляем его как точку отсчета
    const firstProgressBar = document.querySelector(`.${st.progressBar}`)
    if (firstProgressBar) {
      document.documentElement.style.setProperty(
        '--progress-bar-left',
        `${firstProgressBar.offsetLeft}px`,
      )
    }
  }, [])

  const totalDealsTarget = goals.reduce(
    (sum, school) =>
      sum +
      school.managers.reduce(
        (managerSum, manager) => managerSum + Number(manager.deals),
        0,
      ),
    0,
  )

  const targetLocalSum = goals.map((goal) => {
    const totalBudget = goal.managers.reduce(
      (sum, manager) => sum + manager.budget,
      0,
    )
    const totalDeals = goal.managers.reduce(
      (sum, manager) => sum + manager.deals,
      0,
    )
    return {
      name: goal.name,
      totalBudget,
      totalDeals,
    }
  })

  const totalTargetBudget = goals.reduce((sum, school) => {
    return (
      sum +
      school.managers.reduce(
        (managerSum, manager) =>
          managerSum + (manager.budget > 0 ? manager.targetBudget : 0),
        0,
      )
    )
  }, 0)

  const totalTargetDeals = goals.reduce((sum, school) => {
    return (
      sum +
      school.managers.reduce(
        (managerSum, manager) =>
          managerSum + (manager.deals > 0 ? manager.targetDeals : 0),
        0,
      )
    )
  }, 0)

  const progressPercentage =
    currentDayTotal > 0 ? (currentDayTotal / daysInPeriod) * 100 : 0

  const flag = (
    <div
      className={styles.limitLine}
      style={{
        left: `${(currentDayTotal / daysInPeriod) * 100}%`,
      }}
    >
      <div
        className={styles.containerLine}
        style={{ left: `calc(${progressPercentage}% - 10px)` }}
      >
        <div className={styles.dateInf}>
          <div className={styles.flag}>
            <Flag />
          </div>

          <div className={styles.infoDate}>
            <div className={styles.currentDay}>
              {currentDayTotal > 0 ? todayDate.toLocaleDateString() : ''}
            </div>
            <div className={styles.dateTarget}>
              {currentDayTotal} {translate.days} {translate.out_of}{' '}
              {daysInPeriod}
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div className={styles.goalsPage}>
      <div className={styles.controls}>
        <button
          className={sortBy === 'budget' ? styles.active : ''}
          onClick={() => setSortBy('budget')}
        >
          {translate.by_budget}
        </button>
        <button
          className={sortBy === 'quantity' ? styles.active : ''}
          onClick={() => setSortBy('quantity')}
        >
          {translate.by_quantity}
        </button>
      </div>
      <div className={styles.goalsContainer}>
        {flag}
        {goals.map((location, index) => {
          const locationTarget = targetLocalSum.find(
            (sum) => sum.name === location.name,
          )

          return (
            <Location
              translate={translate}
              targetSum={targetLocalSum}
              key={index}
              {...location}
              sortBy={sortBy}
              currentDay={currentDay}
              daysInPeriod={daysInPeriod}
              totalBudget={locationTarget?.totalBudget || 0}
              totalDeals={locationTarget?.totalDeals || 0}
              dateFrom={dateFrom}
              dateUntil={dateUntil}
              today={todayDate}
            />
          )
        })}
      </div>
      <div className={styles.total}>
        <div className={styles.totalRow}>
          <ManagerRow
            translate={translate}
            name={translate.total}
            targetProgress={
              sortBy === 'budget' ? `${totalTargetBudget}₸` : totalTargetDeals
            }
            sortedGoal={
              sortBy === 'budget'
                ? `${Number(totalBudgetTarget)}₸`
                : Number(totalDealsTarget)
            }
            progress={
              sortBy === 'budget' ? totalTargetBudget : totalTargetDeals
            }
            target={sortBy === 'budget' ? totalBudgetTarget : totalDealsTarget}
            limit={
              sortBy === 'budget'
                ? (totalBudgetTarget / daysInPeriod) * currentDay
                : (totalDealsTarget / daysInPeriod) * currentDay
            }
            // flag={flag}
          />
        </div>
      </div>
    </div>
  )
}

export default GoalsChart
